import { useQuery, useMutation, useLazyQuery } from '@apollo/client';
import { GET_NOTES, GET_NOTE_BY_ID, ME } from '../../graphql/queries';
import { CREATE_NOTE, UPDATE_NOTE, DELETE_NOTE, TOGGLE_FAVORITE } from '../../graphql/mutations';

export const useBlogQueries = (setNotes: (notes: any[]) => void) => {
  const { data: meData } = useQuery(ME);
  const isAuthenticated = !!meData?.me;
  const userRole = meData?.me?.role || null;
  const isAdmin = userRole === 'admin' || userRole === 'superadmin';

  const { loading, refetch: originalRefetch } = useQuery<{ notes: any[] }>(GET_NOTES, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      if (data?.notes) setNotes(data.notes);
    },
  });

  // ✅ Оборачиваем refetch, чтобы он ВСЕГДА обновлял локальный стейт после вызова
  const refetchNotes = async () => {
    const result = await originalRefetch();
    if (result.data?.notes) {
      setNotes(result.data.notes);
    }
    return result;
  };

  const [getNoteById] = useLazyQuery<{ note: any }>(GET_NOTE_BY_ID);
  const [createNote] = useMutation(CREATE_NOTE);
  const [updateNote] = useMutation(UPDATE_NOTE);
  const [deleteNote] = useMutation(DELETE_NOTE);
  const [toggleFavorite] = useMutation(TOGGLE_FAVORITE);

  return {
    meData, 
    isAuthenticated, 
    isAdmin, 
    loading, 
    refetch: refetchNotes, // <-- Возвращаем нашу обёртку
    getNoteById, 
    createNote, 
    updateNote, 
    deleteNote, 
    toggleFavorite,
  };
};